<div>
  <span class="description">
    {{ 'AUTOMATIONS.EDITOR.TRIGGERS.SALES_ORDER_EXPIRING.STATUS_DESCRIPTION' | translate }}
  </span>
  <div class="form-container">
    <glxy-select-input
      class="form-control"
      [label]="'AUTOMATIONS.EDITOR.TRIGGERS.SALES_ORDER_EXPIRING.EXPIRY' | translate"
      [formControl]="orderExpiryControl"
      [required]="true"
      [options]="orderExpiryOptions"
    ></glxy-select-input>
  </div>
</div>
